import {
  extractMediaDisplayItems,
  formatMediaDisplayValue,
  isMediaUrl,
  MediaPreviewValue,
} from "../components/MediaPreviewValue";
import type { FieldMapping, FieldResolver } from "./getChanges";

export const MEDIA_URL_FIELD_KEYS = new Set([
  "logoUrl",
  "mediaItems",
  "mediaItem",
  "processedMediaId",
  "profileIconProcessedMediaId",
  "profileIconMediaUrl",
  "walletProcessedMediaId",
  "walletMediaUrl",
  "imageUrl",
  "processedMediaId",
  "branchReceiptMedia",
  "branchReceiptBillNumberMedia",
  "branchReceiptOrderTotalMedia",
]);

const hasRenderableMediaUrl = (value: unknown): boolean =>
  extractMediaDisplayItems(value).some(
    item => item.kind === "text" && isMediaUrl(item.value)
  );

export const MEDIA_URL_FIELD_RESOLVER: FieldResolver = {
  formatValue: formatMediaDisplayValue,
  renderValue: value => {
    if (!hasRenderableMediaUrl(value)) {
      return null;
    }

    return <MediaPreviewValue value={value} />;
  },
};

export const getMediaUrlFieldResolvers = (
  mapKeyToName?: FieldMapping
): Record<string, FieldResolver> => {
  if (!mapKeyToName) {
    return {};
  }

  return Object.keys(mapKeyToName).reduce<Record<string, FieldResolver>>(
    (resolvers, key) => {
      if (MEDIA_URL_FIELD_KEYS.has(key)) {
        resolvers[key] = MEDIA_URL_FIELD_RESOLVER;
      }

      return resolvers;
    },
    {}
  );
};
